<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="检测窗口期" prop="windowTimeList">
                    <el-select v-model="queryCondition.windowTimeList" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%" class="multiple_sel">
                      <el-option v-for="item in windowTimeList" :label="item.name" :value="item.code" :key="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="数据查询范围" prop="queryRange">
                    <el-select v-model="queryCondition.queryRange" @change="queryRangeChange" clearable placeholder="最新全量数据" style="width:100%" class="multiple_sel">
                      <el-option v-for="item in queryRangeLists" :label="item.name" :value="item.code" :key="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="产品编码" prop="fiveBitCode">
                    <el-input v-model="queryCondition.fiveBitCode" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="产品中文名称" prop="describe">
                    <el-input v-model="queryCondition.describe" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="产品英文名称" prop="fiveBitCodeName">
                      <el-input v-model="queryCondition.fiveBitCodeName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="Category2" prop="categoryLevel2CodeList">
                      <el-select v-model="queryCondition.categoryLevel2CodeList" @change="changeCategory2" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%" class="multiple_sel">
                        <el-option v-for="item in categoryList2" :label="item.name" :value="item.code" :key="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="Category3" prop="categoryLevel3CodeList">
                      <el-select v-model="queryCondition.categoryLevel3CodeList" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%" class="multiple_sel">
                        <el-option v-for="item in categoryList3" :label="item.name" :value="item.code" :key="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="结算单位名称" prop="supplierName">
                      <el-input v-model="queryCondition.supplierName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="工厂名称" prop="facilityName">
                      <el-input v-model="queryCondition.facilityName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="检测原因" prop="beSelectedReason">
                      <ic-select table="TT_NUTR_INSPECT" field="BE_SELECTED_REASON" clearable v-model="queryCondition.beSelectedReason" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="烹饪方式" prop="cookCode">
                      <ic-select table="TR_NUTR_GRI_COOK" field="COOK_CODE" clearable v-model="queryCondition.cookCode" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="更新日期倒序" prop="sortByUpdate">
                      <el-checkbox v-model="queryCondition.sortByUpdate"></el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onAdd" v-acl="NUTRITION_INSPECT_ADD">新增</el-button>
        <el-button size="mini" class="btn" type="danger" @click="onDel" v-acl="NUTRITION_INSPECT_DELETE">删除</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onRestore" :disabled="isRDisabled" :loading="isRLoading" v-acl="NUTRITION_INSPECT_RESTORE">恢复</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onConfirm" v-acl="NUTRITION_INSPECT_CONFIRM">确认检测范围</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onCopy" v-acl="NUTRITION_INSPECT_COPY_RESULT">复制检测结果</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onPublish" :disabled="isPDisabled" :loading="isPLoading" v-acl="NUTRITION_INSPECT_RELEASE">发布</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onSubmit" :disabled="isSDisabled" :loading="isSLoading" v-if="isSubmit">提交</el-button>
        <el-dropdown split-button type="primary" placement="bottom" @click="handleClick" v-acl="NUTRITION_INSPECT_IMPORT_DATA,NUTRITION_INSPECT_IMPORT_ATTACHMENT">
          批量导入
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button size="mini" class="dropdownItemBtn" type="primary" @click="onTestData" v-acl="NUTRITION_INSPECT_IMPORT_DATA">营养检测数据</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button size="mini" class="dropdownItemBtn" type="primary" @click="onTestFile" v-acl="NUTRITION_INSPECT_IMPORT_ATTACHMENT">营养检测附件</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button size="mini" class="btn" type="primary" @click="onExport" v-acl="NUTRITION_INSPECT_EXPORT">报表导出</el-button>
      </el-row>
      <el-row>
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="(item,index) in tabLists" :key="index" :name="item.key">
            <span slot="label">{{item.label}}{{'('+item.num+')'}}</span>
            <el-table :data="item.lists" @selection-change="handleSelectionChange" max-height="425" border stripe style="width: 100%">
              <el-table-column type="selection" width="55" fixed="left"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'windowTime')" show-overflow-tooltip prop="windowTime" label="检测窗口期" width="120"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'versionText')" show-overflow-tooltip prop="versionText" label="版本" width="90"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'beSelectedReasonText')" show-overflow-tooltip prop="beSelectedReasonText" label="检测原因" width="120"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'fiveBitCode')" show-overflow-tooltip prop="fiveBitCode" label="产品编码" width="150"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'describe')" show-overflow-tooltip prop="describe" label="产品中文名称" width="150"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'fiveBitCodeName')" show-overflow-tooltip prop="fiveBitCodeName" label="产品英文名称" width="150"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'supplierName')" show-overflow-tooltip prop="supplierName" label="结算单位名称" width="150"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'facilityName')" show-overflow-tooltip prop="facilityName" label="工厂名称" width="150"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'categoryLevel2Name')" show-overflow-tooltip prop="categoryLevel2Name" label="Category2" width="120"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'categoryLevel3Name')" show-overflow-tooltip prop="categoryLevel3Name" label="Category3" width="120"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'cookCodeText')" show-overflow-tooltip prop="cookCodeText" label="烹饪方式" width="90"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'labCodeText')" show-overflow-tooltip prop="labCodeText" label="检测实验室" width="130"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'inspectStatusText')" show-overflow-tooltip prop="inspectStatusText" label="状态" width="100"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'deleteReason')" show-overflow-tooltip prop="deleteReason" label="删除原因" width="150"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'inspectEndDate')" show-overflow-tooltip prop="inspectEndDate" label="检测截至日期" width="120"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'updateByName')" show-overflow-tooltip prop="updateByName" label="更新人" width="120"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'updateDate')" show-overflow-tooltip prop="updateDate" label="更新日期" width="150"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'cqsSubmitByName')" show-overflow-tooltip prop="cqsSubmitByName" label="提交人" width="120"></el-table-column>
              <el-table-column sortable :sort-method="(a,b) => sortMethods(a ,b , 'cqsSubmitDate')" show-overflow-tooltip prop="cqsSubmitDate" label="提交日期" width="150"></el-table-column>
              <el-table-column label="操作" width="180" fixed="right">
                <template slot-scope="scope">
                  <el-button @click="onView(scope.row)" type="text" size="small">查看</el-button>
                  <el-button @click="onEdit(scope.row)" type="text" size="small" v-acl="NUTRITION_INSPECT_SUBMIT" v-if="((isModify1&&(scope.row.inspectStatus=='Released'||scope.row.inspectStatus=='Uploaded'))||(isModify&&(scope.row.inspectStatus=='Uploaded'||scope.row.inspectStatus=='Finalized')))">编辑</el-button>
                  <el-button @click="onMaintenance(scope.row)" type="text" size="small" v-if="scope.row.inspectStatus=='WaitConfirm'" v-acl="NUTRITION_INSPECT_EDIT_RESON">检测原因维护</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-row>
      <el-dialog title="检测原因维护" :visible.sync="dialogVisible1" width="30%" :close-on-click-modal="false" class="fpa" @close="onClose1">
        <el-form ref="maintenanceForm" :model="maintenanceForm" label-width="100px">
          <el-form-item label="产品编码" prop="fiveBitCode">
            <el-input v-model="maintenanceForm.fiveBitCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="产品中文名称" prop="fiveBitCodeName">
            <el-input v-model="maintenanceForm.fiveBitCodeName" disabled></el-input>
          </el-form-item>
          <el-form-item label="工厂名称" prop="facilityName">
            <el-input v-model="maintenanceForm.facilityName" disabled></el-input>
          </el-form-item>
          <el-form-item label="检测原因" prop="inspectReason" :rules="{required: true, message: '检测原因不能为空', trigger: 'change'}">
            <ic-select table="TT_NUTR_INSPECT" field="BE_SELECTED_REASON" clearable v-model="maintenanceForm.inspectReason" style="width:100%"></ic-select>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" @click="onSaveMain" :disabled="isSaveDisabled" :loading="isSaveLoading">保存</el-button>
          <el-button size="mini" class="btn" @click="onClose1">取消</el-button>
        </el-row>
      </el-dialog>
      <!-- <el-dialog title="修改备注" :visible.sync="dialogVisible2" width="30%" :close-on-click-modal="false" class="fpa" @close="onClose2">
        <el-form ref="remarkForm" :model="remarkForm" label-width="100px">
          <el-form-item label="备注" prop="name">
            <el-input v-model="remarkForm.name" type="textarea" :rows="2"></el-input>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" @click="onSaveNote">保存</el-button>
          <el-button size="mini" class="btn" @click="onClose2">取消</el-button>
        </el-row>
      </el-dialog> -->
      <el-dialog title="选择复制检测结果" :visible.sync="dialogVisible3" width="50%" :close-on-click-modal="false" class="fpa" @close="onClose3">
        <el-table ref="singleTable" :data="testData" style="width: 100%">
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-radio v-model="selectOneData" :label="scope.row">{{scope.row.name}}</el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="windowTime" label="窗口期" min-width="120"></el-table-column>
          <el-table-column prop="versionText" label="版本" min-width="100"></el-table-column>
          <el-table-column prop="fiveBitCodeName" label="产品名称" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="facilityName" label="工厂名称" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="cookCodeText" label="烹饪方式" min-width="150" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" @click="onSaveCopy" :disabled="isCDisabled" :loading="isCLoading">确认</el-button>
          <el-button size="mini" class="btn" @click="onClose3">关闭</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="检测数据范围" :visible.sync="dialogVisible4" width="30%" :close-on-click-modal="false" class="fpa" @close="onClose4">
        <el-form ref="rangeForm" :model="rangeForm" label-width="100px" class="user_table">
          <h4>请确认本次检测窗口期的数据范围：</h4>
          <el-form-item label="检测窗口期:" prop="windowTime">
            <span>{{rangeForm.windowTime}}</span>
          </el-form-item>
          <el-form-item label="Category:" prop="category">
            <span>{{rangeForm.category}}</span>
          </el-form-item>
          <el-form-item label="检测数据:" prop="inspectCount">
            <span>{{rangeForm.inspectCount}}条</span>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" @click="onSaveData" :disabled="isConfirmDisabled" :loading="isConfirmLoading">确认</el-button>
          <el-button size="mini" class="btn" @click="onClose4">取消</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="批量导入" :visible.sync="dialogVisible5" width="30%" :close-on-click-modal="false" class="fpa" @close="onClose5">
        <el-row type="flex" justify="start">
          <el-upload ref="upload" name="file" action="" :http-request="httpRequest" :show-file-list="false">
            <el-button size="small" type="primary">选择文件</el-button>
          </el-upload>
          <el-button size="mini" class="btn" type="primary" @click="onDownloadTem" v-if="flag=='data'" style="margin-left:10px!important">导入模板下载</el-button>
          <el-button size="mini" class="btn" type="primary" @click="onDownloadName" v-if="flag=='file'" style="margin-left:10px!important">附件命名模板下载</el-button>
        </el-row>
        <el-row style="margin-top:8px">
          <el-input v-model="fileName" disabled></el-input>
        </el-row>
        <el-row style="margin-top:8px">
          <ul v-if="flag=='data'">
            <li style="font-size:16px;font-weight:600;color:red">说明:</li>
            <li style="color:red">1.请点击模板下载,按照模板填写后再上传</li>
            <li style="color:red">2.模板中红色字段为必填项,请务必正确填写</li>
            <li style="color:red">3.仅支持上传Excel格式文件,且大小不能超过20M</li>
            <li style="color:red">4.为保证上传成功,请勿对模板中的单元格进行修改</li>
            <li style="color:red">5.一次仅支持一份文件上传,多份文件上传将会替换原文件</li>
          </ul>
          <ul v-if="flag=='file'">
            <li style="font-size:16px;font-weight:600;color:red">说明:</li>
            <li style="color:red">1.附件请按照命名模板重命名</li>
          </ul>
        </el-row>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" @click="onUpload">上传</el-button>
          <el-button size="mini" class="btn" @click="onClose5">关闭</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="Ingredient主数据" :visible.sync="dialogVisible6" width="80%" :close-on-click-modal="false" class="fpa" @close="closeAdd">
        <ingredientDialog :addInfo="addInfo" @closeAdd="closeAdd" @setParam="setParam"></ingredientDialog>
      </el-dialog>
      <el-dialog title="删除原因" :visible.sync="dialogVisible7" width="30%" :close-on-click-modal="false" class="fpa" @close="onCloseDel">
        <el-form ref="delForm" :model="delForm" :rules="delRules" label-width="70px">
          <el-form-item label="删除原因" prop="deleteReason">
            <el-input v-model="delForm.deleteReason" type="textarea" :rows="4"></el-input>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button size="mini" class="btn" type="primary" @click="onSaveDel" :disabled="isDelDisabled" :loading="isDelLoading">保存</el-button>
          <el-button size="mini" class="btn" @click="onCloseDel">取消</el-button>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import nutriApi from "@/api/Nutrition/index";
import paginationMixin from '@/mixins/pagitionMixin';
import { apiService } from "@/api/material/material-master-data";
import { fileService } from "@/api/common/file-utils";
import IcSelect from "@/components/common/icSelect";
import ingredientDialog from "./nutritionAdd";

export default {
  // name: 'Window',
  mixins: [paginationMixin],
  components: { IcSelect, ingredientDialog },
  data() {
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        windowTimeList: [],
        queryRange: "IN_WINDOW",
        fiveBitCode: "",
        fiveBitCodeName: "",
        describe: "",
        categoryLevel2CodeList: [],
        categoryLevel3CodeList: [],
        supplierName: "",
        facilityName: "",
        beSelectedReason: "",
        inspectStatus: "",
        cookCode: "",
        sortByUpdate: false,
      },
      totalCount: 0,
      pages: 1,
      isShow: false,
      dialogVisible1: false,
      // dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,
      dialogVisible7: false,
      isSubmit: false,
      isCDisabled: false,
      isCLoading: false,
      isRDisabled: false,
      isRLoading: false,
      isPDisabled: false,
      isPLoading: false,
      isSDisabled: false,
      isSLoading: false,
      isDelDisabled: false,
      isDelLoading: false,
      isConfirmDisabled: false,
      isConfirmLoading: false,
      isSaveDisabled: false,
      isSaveLoading: false,
      categoryList1: [],
      categoryList2: [],
      categoryList3: [],
      windowTimeList: [],
      queryRangeLists: [
        {
          name: "检测窗口期数据",
          code: "IN_WINDOW",
        },
        {
          name: "最新全量数据",
          code: "LAST_WINDOW_VERSION",
        }
      ],
      // 检测原因维护
      maintenanceForm: {
        fiveBitCode: "",
        fiveBitCodeName: "",
        facilityName: "",
        inspectReason: "",
      },
      // // 修改备注
      // remarkForm: {},
      // 选择复制检测结果
      testData: [],
      selectOneData: null,
      // 检测数据范围
      rangeForm: {
        windowTime: "",
        category: "",
        inspectCount: "",
      },
      // 删除原因
      delForm: {
        deleteReason: "",
      },
      fileList: [],
      uploadForm: {
        files: [],
      },
      fileName: "",
      rules: {
        name: [
          { required: true, message: '请输入文件描述', trigger: 'blur' },
        ],
      },
      delRules: {
        deleteReason: [
          { required: true, message: '请输入删除原因', trigger: 'blur' },
        ],
      },
      flag: '',
      activeName: "All",
      tabLists: [
        {
          label: "全部",
          key: "All",
          num: "",
          lists: [],
        },
        {
          label: "已删除",
          key: "Deleted",
          num: "",
          lists: [],
        },
        {
          label: "待CQS确认",
          key: "WaitConfirm",
          num: "",
          lists: [],
        },
        {
          label: "待Owner发布",
          key: "WaitRelease",
          num: "",
          lists: [],
        },
        {
          label: "已发布",
          key: "Released",
          num: "",
          lists: [],
        },
        {
          label: "已上传检测结果",
          key: "Uploaded",
          num: "",
          lists: [],
        },
        {
          label: "已定版",
          key: "Finalized",
          num: "",
          lists: [],
        },
      ],
      addInfo: null,//传给新增弹窗的数据
      multipleSelection: [],
      inspectIdList: [],
      isModify: false,
      isModify1: false
    };
  },
  // watch: {
  //   queryCondition() {
  //     let _this = this;
  //     store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
  //   }
  // },
  // beforeRouteEnter(to, from, next) {
  // QIPApi.findListPage(to.meta.reqData).then((res) => {
  //   next(vm => {
  //     vm.queryCondition = to.meta.reqData;
  //     vm.tableData = res.data.records;
  //     vm.totalCount = res.data.total;
  //   })
  // })
  // },
  mounted() {
    if (this.$route.query.CATEGORY2_CODE) {
      this.queryCondition.categoryLevel2CodeList = []
      this.queryCondition.categoryLevel2CodeList.push(this.$route.query.CATEGORY2_CODE)
    }
    if (this.$route.query.STATUS) {
      this.activeName = this.$route.query.STATUS
    }
    this.getWindowTimeList()
    this.getCategory1()
    var permission = JSON.parse(localStorage.getItem('ms_Permission'))
    var ms_emplFlag = localStorage.getItem('ms_emplFlag')
    console.log("🚀 ~ file: nutritionDetection.vue:455 ~ mounted ~ ms_emplFlag:", ms_emplFlag)
    console.log("🚀 ~ file: nutritionDetection.vue:412 ~ mounted ~ permission:", permission)
    if (permission.indexOf('NUTRITION_LAB_AUDIT') != -1 && permission.indexOf('NUTRITION_INSPECT_SUBMIT') != -1) {
      this.isSubmit = true
    } else {
      this.isSubmit = false
    }
    if (permission.indexOf('NUTRITION_CQS_OWNER_AUDIT') != -1) {
      this.isModify = true
    } else {
      this.isModify = false
    }
    if (permission.indexOf('NUTRITION_LAB_AUDIT') != -1) {
      this.isModify1 = true
    } else {
      this.isModify1 = false
    }
    if (permission.indexOf('NUTRITION_LAB_AUDIT') != -1 || ms_emplFlag === 'SUP') {
      this.tabLists = [
        {
          label: "全部",
          key: "All",
          num: "",
          lists: [],
        },
        {
          label: "已发布",
          key: "Released",
          num: "",
          lists: [],
        },
        {
          label: "已上传检测结果",
          key: "Uploaded",
          num: "",
          lists: [],
        },
        {
          label: "已定版",
          key: "Finalized",
          num: "",
          lists: [],
        },
      ]
    }
    console.log('this.isModify', this.isModify)
    console.log('this.isModify1', this.isModify1)
  },
  methods: {
    queryRangeChange(val) {
      console.log("🚀 ~ file: nutritionDetection.vue:501 ~ queryRangeChange ~ val:", val)
      if (val === 'LAST_WINDOW_VERSION') {
        this.$set(this.queryCondition, 'windowTimeList', [])
      }
    },
    queryData() {
      delete this.queryCondition.inspectIdList
      if (this.activeName == 'All') {
        this.$set(this.queryCondition, 'inspectStatus', '')
      } else {
        this.$set(this.queryCondition, 'inspectStatus', this.activeName)
      }
      nutriApi.findNutritionQuery(this.queryCondition).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:513 ~ nutriApi.findNutritionQuery ~ res:", res)
        this.tabLists.forEach(ele => {
          if (ele.key == 'All') {
            this.$set(ele, 'num', res.resultData.allCount)
          }
          if (ele.key == 'Deleted') {
            this.$set(ele, 'num', res.resultData.deletedCount)
          }
          if (ele.key == 'WaitConfirm') {
            this.$set(ele, 'num', res.resultData.waitConfirmCount)
          }
          if (ele.key == 'WaitRelease') {
            this.$set(ele, 'num', res.resultData.waitReleaseCount)
          }
          if (ele.key == 'Released') {
            this.$set(ele, 'num', res.resultData.releasedCount)
          }
          if (ele.key == 'Uploaded') {
            this.$set(ele, 'num', res.resultData.uploadedCount)
          }
          if (ele.key == 'Finalized') {
            this.$set(ele, 'num', res.resultData.finalizedCount)
          }
          if (ele.key == this.activeName) {
            this.$set(ele, 'lists', res.resultData.inspectList)
          }
        })
        console.log('this.tabLists', this.tabLists)
        this.totalCount = res.totalCount
      });
    },
    getCategory1() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
        var pid
        res.data.forEach(ele => {
          if (ele.code == '10' && ele.name == 'Food') {
            pid = ele.tmCategoryId
          }
        })
        this.getCategory2(pid)
      });
    },
    getCategory2(pid) {
      apiService.findCategory({ categoryLevel: 2, pid: pid }).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:507 ~ apiService.findCategory ~ res:", res)
        this.categoryList2 = res.data;
      });
    },
    changeCategory2() {
      this.categoryList3 = []
      var category2Codes = []
      this.categoryList2.forEach(ele => {
        if (this.queryCondition.categoryLevel2CodeList.includes(ele.code)) {
          category2Codes.push(ele.tmCategoryId)
        }
      })
      apiService.findCategory({ categoryLevel: 3, pidList: category2Codes }).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:515 ~ apiService.findCategory ~ res:", res)
        this.categoryList3 = res.data;
      });
    },
    // 获取窗口期下拉值
    getWindowTimeList() {
      nutriApi.getWindowTimeList().then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:528 ~ nutriApi.getWindowTimeList ~ res:", res)
        this.windowTimeList = res.data;
        res.data.forEach(ele => {
          if (ele.isDefault) {
            this.queryCondition.windowTimeList.push(ele.code)
            this.defaultMonth = ele.code
            this.queryData()
          }
        })
      });
    },
    handleClick(tab, event) {
      this.activeName = tab.name
      this.queryCondition.pageSize = 15
      this.queryCondition.pageNum = 1
      this.queryData()
    },
    // 新增
    onAdd() {
      nutriApi.findNutritionAddQuery(this.queryCondition).then((res) => {
        console.log("🚀 ~ file: nutritionAdd.vue:150 ~ nutriApi.findNutritionAddQuery ~ res:", res)
        if (res) {
          this.addInfo = JSON.stringify(res)
          this.dialogVisible6 = true
        }
      }).catch(error => {
        console.log("🚀 ~ file: nutritionDetection.vue:451 ~ nutriApi.findNutritionAddQuery ~ error:", error.response)
      })
    },
    setParam() {
      this.$set(this.queryCondition, 'sortByUpdate', true)
      this.dialogVisible6 = false
      this.queryData()
    },
    closeAdd() {
      this.dialogVisible6 = false
      this.queryData()
    },
    // 删除
    onDel() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择需要删除的数据后再进行操作')
        return false
      }
      var isFlag = this.multipleSelection.every(ele => {
        return ele.inspectStatus === 'WaitConfirm'
      })
      if (!isFlag) {
        this.$message.error('存在状态不为待CQS确认的数据，无法删除！')
        return false
      }
      this.dialogVisible7 = true
    },
    onSaveDel() {
      this.$refs['delForm'].validate((valid) => {
        if (valid) {
          this.isDelDisabled = true
          this.isDelLoading = true
          nutriApi.inspectDelete({
            deleteReason: this.delForm.deleteReason,
            inspectIdList: this.inspectIdList
          }).then((res) => {
            console.log("🚀 ~ file: nutritionDetection.vue:501 ~ onSaveDel ~ res:", res)
            this.isDelDisabled = false
            this.isDelLoading = false
            if (res) {
              this.$message.success('删除成功!')
              this.dialogVisible7 = false
              this.queryData()
            }
          }).catch(error => {
            this.isDelDisabled = false
            this.isDelLoading = false
            console.log("🚀 ~ file: nutritionDetection.vue:507 ~ onSaveDel ~ error:", error.response)
          })
        }
      })
    },
    onCloseDel() {
      this.dialogVisible7 = false
      this.delForm.deleteReason = ''
    },
    // 恢复
    onRestore() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择需要恢复的数据后再进行操作')
        return false
      }
      var isFlag = this.multipleSelection.every(ele => {
        return ele.inspectStatus === 'Deleted'
      })
      if (!isFlag) {
        this.$message.error('存在状态不为已删除的数据，无法恢复！')
        return false
      }
      this.isRDisabled = true
      this.isRLoading = true
      nutriApi.inspectRestore({
        idList: this.inspectIdList
      }).then((res) => {
        this.isRDisabled = false
        this.isRLoading = false
        console.log("🚀 ~ file: nutritionDetection.vue:530 ~ onRestore ~ res:", res)
        if (res) {
          this.$message.success('恢复成功!')
          this.queryData()
        }
      }).catch(error => {
        this.isRDisabled = false
        this.isRLoading = false
        console.log("🚀 ~ file: nutritionDetection.vue:536 ~ onRestore ~ error:", error.response)
      })
      
    },
    onPublish() {
      this.isPDisabled = true
      this.isPLoading = true
      nutriApi.inspectRelease().then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:636 ~ nutriApi.inspectRelease ~ res:", res)
        this.isPDisabled = false
        this.isPLoading = false
        if (res) {
          this.$message.success('发布成功,您已发布' + res.data.count + '条数据在检测窗口期：' + res.data.windowTime + '。')
          this.queryData()
        }
      }).catch(error => {
        this.isPDisabled = false
        this.isPLoading = false
        console.log("🚀 ~ file: nutritionDetection.vue:549 ~ onPublish ~ error:", error.response)
      })
    },
    onMaintenance(row) {
      this.dialogVisible1 = true
      this.maintenanceForm = {
        fiveBitCode: row.fiveBitCode,
        fiveBitCodeName: row.fiveBitCodeName,
        facilityName: row.facilityName,
        inspectReason: row.inspectReason,
        inspectId: row.inspectId,
      }
    },
    onSaveMain() {
      this.$refs['maintenanceForm'].validate((valid) => {
        if (valid) {
          this.isSaveDisabled = true
          this.isSaveLoading = true
          nutriApi.editInspectReason({
            inspectId: this.maintenanceForm.inspectId,
            inspectReason: this.maintenanceForm.inspectReason,
          }).then((res) => {
            console.log("🚀 ~ file: nutritionDetection.vue:585 ~ nutriApi.editInspectReason ~ res:", res)
            this.isSaveDisabled = false
            this.isSaveLoading = false
            if (res) {
              this.$message.success('保存成功!')
              this.dialogVisible1 = false
              this.$refs['maintenanceForm'].resetFields();
              this.queryData()
            }
          }).catch(error => {
            this.isSaveDisabled = false
            this.isSaveLoading = false
            console.log("🚀 ~ file: nutritionDetection.vue:549 ~ onPublish ~ error:", error.response)
          })
        }
      })

    },
    onClose1() {
      this.dialogVisible1 = false
    },
    onSubmit() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请至少勾选一条数据进行操作')
        return false
      }
      this.isSDisabled = true
      this.isSLoading = true
      nutriApi.queryInspectSubmit({
        idList: this.inspectIdList
      }).then((res) => {
        this.isSDisabled = false
        this.isSLoading = false
        if (res) {
          this.$message.success('提交成功!')
          this.queryData()
        }
      }).catch(error => {
        this.isSDisabled = false
        this.isSLoading = false
        console.log("🚀 ~ file: nutritionDetection.vue:549 ~ onPublish ~ error:", error.response)
      })
    },
    // onSaveNote() {

    // },
    // onClose2() {
    //   this.dialogVisible2 = false
    // },
    onCopy() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择需要复制的数据后再进行操作')
        return false
      }
      if (this.multipleSelection.length > 1) {
        this.$message.error('请仅勾选一条数据进行操作')
        return false
      }
      var isFlag = this.multipleSelection.every(ele => {
        return ele.inspectStatus === 'WaitConfirm'
      })
      if (!isFlag) {
        this.$message.error('不存在状态为待CQS确认的数据，请检查！')
        return false
      }
      nutriApi.getCopyList(this.multipleSelection[0].inspectId).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:578 ~ nutriApi.getCopyList ~ res:", res)
        if (res.code == '200') {
          this.testData = res.data
          this.dialogVisible3 = true
        }
      }).catch(error => {
        console.log("🚀 ~ file: nutritionDetection.vue:584 ~ nutriApi.getCopyList ~ error:", error.response)
      })
    },
    onSaveCopy() {
      if (!this.selectOneData) {
        this.$message.error('请先选择需要复制的数据后再进行操作')
        return false
      }
      this.isCDisabled = true
      this.isCLoading = true
      console.log('selectOneData', this.selectOneData);
      nutriApi.saveCopy({
        beCopyInspectId: this.selectOneData.inspectId,
        inspectId: this.multipleSelection[0].inspectId,
      }).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:717 ~ onSaveCopy ~ res:", res)
        this.isCDisabled = false
        this.isCLoading = false
        this.dialogVisible3 = false
        this.$message.success('复制成功')
        this.queryData()
      }).catch(error => {
        this.isCDisabled = false
        this.isCLoading = false
        console.log("🚀 error.response:", error.response)
      })
    },
    onClose3() {
      this.dialogVisible3 = false
      this.selectOneData = null
    },
    // 确认检测范围
    onConfirm() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择需要确认的数据后再进行操作')
        return false
      }
      var isFlag = this.multipleSelection.every(ele => {
        return ele.inspectStatus === 'WaitConfirm'
      })
      if (!isFlag) {
        this.$message.error('不存在状态为待CQS确认的数据，请检查！')
        return false
      }
      nutriApi.inspectConfirm({
        ignoreCheck: false,
        inspectIdList: this.inspectIdList
      }).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:599 ~ onConfirm ~ res:", res)
        if (res) {
          this.dialogVisible4 = true
          this.rangeForm = res.data
        }
      }).catch(error => {
        console.log("🚀 ~ file: nutritionDetection.vue:605 ~ onConfirm ~ error:", error.response)
      })
    },
    onSaveData() {
      this.isConfirmDisabled = true
      this.isConfirmLoading = true
      nutriApi.inspectConfirm({
        ignoreCheck: true,
        inspectIdList: this.inspectIdList
      }).then((res) => {
        console.log("🚀 ~ file: nutritionDetection.vue:642 ~ onSaveData ~ res:", res)
        this.isConfirmDisabled = false
        this.isConfirmLoading = false
        if (res.code === '200') {
          this.dialogVisible4 = false
          this.$message.success('确认成功!')
          this.queryData()
        }
      }).catch(error => {
        this.isConfirmDisabled = false
        this.isConfirmLoading = false
        console.log("🚀 ~ file: nutritionDetection.vue:647 ~ onSaveData ~ error:", error.response)
      })
    },
    onClose4() {
      this.dialogVisible4 = false
    },
    // 导入模板下载/导入营养检测数据
    onTestData() {
      this.dialogVisible5 = true
      this.flag = 'data'
    },
    // 附件命名模板下载/导入营养检测附件
    onTestFile() {
      this.dialogVisible5 = true
      this.flag = 'file'
    },
    httpRequest(param) {
      console.log("🚀 ~ file: nutritionDetection.vue:716 ~ httpRequest ~ param:", param)
      this.uploadForm.files = []
      this.uploadForm.files.push(param.file)
      this.fileName = param.file.name
    },
    onUpload() {
      console.log("🚀 ~ file: nutritionDetection.vue:825 ~ this.uploadForm.files.forEach ~ this.uploadForm.files:", this.uploadForm.files)
      if (this.uploadForm.files.length === 0) {
        this.$message.error('请先选择文件，然后点击上传按钮进行批量导入')
        return false
      }
      let formData = new FormData();
      this.uploadForm.files.forEach((v) => {
        formData.append('file', v, v.name)
      })
      // 导入营养检测数据
      if (this.flag === 'data') {
        formData.append("ignoreCheck", false);
        nutriApi.fileUploadExcel(formData).then((res) => {
          console.log("🚀 ~ file: nutritionDetection.vue:720 ~ nutriApi.fileUploadExcel ~ res:", res)
          if (res.code == '200') {
            this.$message.success('上传成功')
            this.dialogVisible5 = false
            this.queryData()
            this.fileName = ''
            this.uploadForm.files = []
            this.$refs.upload.clearFiles()
          } else if (res.code == '601') {
            let str = res.msg;
            str = str.replace(/\n/g, '<br>')
            this.$confirm(str, '波动幅度超过50%提示', {
              confirmButtonText: '确认',
              confirmButtonClass: "confirmButtonClass",
              cancelButtonClass: "cancelButtonClass",
              cancelButtonText: '取消',
              customClass: "nutriUploadBtn",
              type: 'warning',
              dangerouslyUseHTMLString: true,
            }).then(() => {
              // formData.delete("ignoreCheck");
              // formData.set("ignoreCheck", true);
              let formData1 = new FormData();
              this.uploadForm.files.forEach((v) => {
                formData1.append('file', v, v.name)
              })
              formData1.append("ignoreCheck", true);
              nutriApi.fileUploadExcel(formData1).then(res => {
                console.log("🚀 ~ file: nutritionDetection.vue:750 ~ nutriApi.fileUploadExcel ~ res:", res)
                if (res.code == '200') {
                  this.$message.success('上传成功')
                  this.dialogVisible5 = false
                  this.queryData()
                  this.fileName = ''
                  this.uploadForm.files = []
                  this.$refs.upload.clearFiles()
                }
              })
            }).catch((error) => {
              console.log("🚀 ~ file: nutritionDetection.vue:877 ~ nutriApi.fileUploadExcel ~ error:", error)
              this.$message.info('已取消')
              this.fileName = ''
              this.uploadForm.files = []
              this.$refs.upload.clearFiles()
            })
          } else if (res.code == '602') {
            var wordText = res.data.split('\n')
            console.log("🚀 ~ file: nutritionDetection.vue:760 ~ nutriApi.fileUploadZip ~ wordText:", wordText)
            var newArr = []
            const h = this.$createElement;
            for (const i in wordText) {
              newArr.push(h('p', null, wordText[i]))
            }
            this.$confirm('导入错误信息是否下载?', {
              // title: '导入错误信息',
              // message: h('div', null, newArr),
              showCancelButton: true,
              confirmButtonText: '导入错误信息下载',
              confirmButtonClass: "confirmButtonClass",
              cancelButtonClass: "cancelButtonClass",
              cancelButtonText: '取消',
              customClass: "nutriUploadBtn",
              type: 'warning'
            }).then(() => {
              let str = new Blob([res.data], { type: 'text/plain;charset=utf-8' })
              saveAs(str, '导入错误信息.txt')
              this.fileName = ''
              this.uploadForm.files = []
              this.$refs.upload.clearFiles()
            }).catch(() => {
              this.$message.info('已取消导出失败原因')
              this.fileName = ''
              this.uploadForm.files = []
              this.$refs.upload.clearFiles()
            })
          } else {
            this.$message.error('文件上传失败')
            this.fileName = ''
            this.uploadForm.files = []
            this.$refs.upload.clearFiles()
          }
        }).catch((error) => {
          console.log("🚀 ~ file: nutritionDetection.vue:729 ~ nutriApi.fileUploadExcel ~ error:", error.response)
          //文件上传失败
          this.$message.error(error.data.message)
          this.fileName = ''
          this.uploadForm.files = []
          this.$refs.upload.clearFiles()
        });
      } else {
        nutriApi.fileUploadZip(formData).then((res) => {
          console.log("🚀 ~ file: nutritionDetection.vue:737 ~ nutriApi.fileUploadZip ~ res:", res)
          if (res.code == '200') {
            this.$message.success('上传成功')
            this.dialogVisible5 = false
            this.queryData()
          } else if (res.code == '602') {
            var wordText = res.data.split('\n')
            console.log("🚀 ~ file: nutritionDetection.vue:760 ~ nutriApi.fileUploadZip ~ wordText:", wordText)
            var newArr = []
            const h = this.$createElement;
            for (const i in wordText) {
              newArr.push(h('p', null, wordText[i]))
            }
            this.$confirm('导入错误信息是否下载?', {
              // title: '导入错误信息',
              // message: h('div', null, newArr),
              showCancelButton: true,
              confirmButtonText: '导入错误信息下载',
              confirmButtonClass: "confirmButtonClass",
              cancelButtonClass: "cancelButtonClass",
              cancelButtonText: '取消',
              customClass: "nutriUploadBtn",
              type: 'warning'
            }).then(() => {
              let str = new Blob([res.data], { type: 'text/plain;charset=utf-8' })
              saveAs(str, '导入错误信息.txt')
            }).catch(() => {
              this.$message.info('已取消导出失败原因')
            })
          } else {
            this.$message.error('文件上传失败')
          }
          this.fileName = ''
          this.uploadForm.files = []
          this.$refs.upload.clearFiles()
        }).catch((error) => {
          console.log("🚀 ~ file: nutritionDetection.vue:729 ~ nutriApi.fileUploadExcel ~ error:", error.response)
          //文件上传失败
          this.$message.error(error.data.message)
          this.fileName = ''
          this.uploadForm.files = []
          this.$refs.upload.clearFiles()
        });
      }
    },
    onDownloadTem() {
      nutriApi.downloadImportTemplate().then(res => {
        console.log("🚀 ~ file: nutritionDetection.vue:726 ~ nutriApi.downloadImportTemplate ~ res:", res)
      });
    },
    onDownloadName() {
      nutriApi.downloadAttachmentTemplate().then(res => {
        console.log("🚀 ~ file: nutritionDetection.vue:731 ~ nutriApi.downloadAttachmentTemplate ~ res:", res)
        // if (commonFun.isEmpty(res)) {
        //   Message.warning("未找到模板文件！");
        // }
        // fileService.downloadFile(res[0]);
      });
    },
    onClose5() {
      this.dialogVisible5 = false
      this.fileName = ''
      this.uploadForm.files = []
      this.$refs.upload.clearFiles()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.inspectIdList = []
      val.forEach(ele => {
        this.inspectIdList.push(ele.inspectId)
      })
    },
    onExport() {
      this.$set(this.queryCondition, 'inspectIdList', this.inspectIdList)
      nutriApi.downloadQueryLists(this.queryCondition).then(res => {
        console.log("🚀 ~ file: nutritionDetection.vue:731 ~ nutriApi.downloadAttachmentTemplate ~ res:", res)
      });
    },
    onView(row) {
      this.$router.push({
        path: "/nutritionInspect/detail",
        query: {
          type: "view",
          id: row.inspectId
        }
      })
    },
    onEdit(row) {
      this.$router.push({
        path: "/nutritionInspect/detail",
        query: {
          type: "edit",
          id: row.inspectId
        }
      })
    },
    onSearch() {
      this.queryCondition.pageNum = 1;
      this.queryData()
    },
    onReset() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        windowTimeList: [],
        queryRange: "IN_WINDOW",
        fiveBitCode: "",
        fiveBitCodeName: "",
        describe: "",
        categoryLevel2CodeList: [],
        categoryLevel3CodeList: [],
        supplierName: "",
        facilityName: "",
        beSelectedReason: "",
        cookCode: "",
        sortByUpdate: false,
      }
      this.windowTimeList.forEach(ele => {
        if (ele.isDefault) {
          this.queryCondition.windowTimeList.push(ele.code)
          this.defaultMonth = ele.code
        }
      })
      this.queryData()
    },
    sortMethods(a, b, proptype) {
      var prop
      if (proptype === 'labSubmitDate') {
        prop = 'labSubmitDateMiss'
      } else if (proptype === 'updateDate') {
        prop = 'updateDateMiss'
      } else if (proptype === 'inspectEndDate') {
        prop = 'inspectEndDateMiss'
      } else if (proptype === 'createDate') {
        prop = 'createDateMiss'
      } else if (proptype === 'cqsSubmitDate') {
        prop = 'cqsSubmitDateMiss'
      } else {
        prop = proptype
      }
      if (a[prop] === null || a[prop] === undefined) {
        return 1; // 将空值排在后面
      } else if (b[prop] === null || b[prop] === undefined) {
        return -1; // 将空值排在后面
      } else {
        // 自定义排序逻辑
        if (typeof a[prop] === 'string' && typeof b[prop] === 'string') {
          return a[prop].localeCompare(b[prop])
        } else {
          return a[prop] - b[prop];
        }
      }
    },
    compare(propertyName, sort) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName]
        var value2 = obj2[propertyName]
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          const res = value1.localeCompare(value2, 'zh')
          return sort === 'ascending' ? res : -res
        } else {
          if (value1 <= value2) {
            return sort === 'ascending' ? -1 : 1
          } else if (value1 > value2) {
            return sort === 'ascending' ? 1 : -1
          }
        }
      }
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
  }
}
</script>
  